import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProductServiceService } from 'src/app/services/product-service.service';

@Component({
  selector: 'app-delete-category',
  templateUrl: './delete-category.component.html',
  styleUrls: ['./delete-category.component.scss']
})
export class DeleteCategoryComponent {

      constructor(
        public dialogRef: MatDialogRef<DeleteCategoryComponent>,
        @Inject(MAT_DIALOG_DATA) public data:any,
        private productserivice: ProductServiceService,
        
      ){
    
      }

            stateId : any ;
  ngOnInit() {
    this.stateId = this.data.data;
  }
      deleteState(){
    this.productserivice.deleteCategory(this.stateId).subscribe({
      next:(res:any)=>{
          this.productserivice.openSnack("State Deleted sucessfully","Close");
          this.dialogRef.close('success');
      },
      error:(err)=>{
        this.productserivice.openSnack(err.error.message,"close");
      }
    })
  }

  closeBtn(){
    this.dialogRef.close();
  }
}
